import styled from "styled-components";
import ColorWrapper from "../ColorWrapper";

export const FooterContainer = styled.div`
  padding-top: 15px;
`;

export const DetailsCardWrapper = styled(ColorWrapper)`
  max-width: 436px;
`;
